<section class="account-page">
  <div class="account-header">
    <h1>{{ 'LISTINGS.TITLE' | translate }}</h1>
    <p>{{ 'LISTINGS.SUBTITLE' | translate }}</p>
  </div>

  <div class="listings-toolbar">
    <div class="status" *ngIf="isLoading">{{ 'LISTINGS.LOADING' | translate }}</div>
    <div class="status error" *ngIf="!isLoading && errorMessage">
      {{ errorMessage | translate }}
    </div>
    <button class="primary-btn" type="button" (click)="openNewListing()">
      {{ 'LISTINGS.NEW' | translate }}
    </button>
  </div>

  <div class="account-card form-card" *ngIf="isFormOpen">
    <div class="form-header">
      <h2>
        {{ editingId ? ('LISTINGS.EDIT_TITLE' | translate) : ('LISTINGS.NEW_TITLE' | translate) }}
      </h2>
      <button class="ghost-btn" type="button" (click)="cancelForm()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>

    <div class="form-grid">
      <label>
        <span>{{ 'LISTINGS.FIELD_NAME' | translate }}</span>
        <input type="text" [(ngModel)]="form.name" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_SKU' | translate }}</span>
        <input type="text" [(ngModel)]="form.sku" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_PRICE' | translate }}</span>
        <input type="number" min="0" step="0.01" [(ngModel)]="form.price" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_CURRENCY' | translate }}</span>
        <input type="text" maxlength="3" [(ngModel)]="form.currency" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_CATEGORY' | translate }}</span>
        <select [(ngModel)]="selectedParentId" (ngModelChange)="onParentCategoryChange($event)">
          <option [ngValue]="null">{{ 'LISTINGS.FIELD_CATEGORY_PLACEHOLDER' | translate }}</option>
          <option *ngFor="let category of categories" [ngValue]="category.id">{{ category.name }}</option>
        </select>
      </label>

      <label>
        <span>{{ 'LISTINGS.FIELD_SUBCATEGORY' | translate }}</span>
        <select [(ngModel)]="form.categoryId" [disabled]="!selectedParentId">
          <option [ngValue]="null">{{ 'LISTINGS.FIELD_SUBCATEGORY_PLACEHOLDER' | translate }}</option>
          <option *ngFor="let sub of subcategories" [ngValue]="sub.id">{{ sub.name }}</option>
        </select>
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_STOCK' | translate }}</span>
        <input type="number" min="0" [(ngModel)]="form.stockQty" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_BRAND' | translate }}</span>
        <input type="text" [(ngModel)]="form.brand" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_LOCATION_SEARCH' | translate }}</span>
        <input
          type="text"
          [value]="locationQuery"
          (input)="searchLocation($any($event.target).value)"
          autocomplete="off"
        />
        <div class="location-results" *ngIf="locationResults.length">
          <button
            type="button"
            class="location-result"
            *ngFor="let result of locationResults"
            (click)="selectLocation(result)">
            {{ result.label }}
          </button>
        </div>
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_LOCATION' | translate }}</span>
        <input type="text" [(ngModel)]="form.locationText" />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_LATITUDE' | translate }}</span>
        <input
          type="number"
          step="0.000001"
          [ngModel]="form.latitude"
          (ngModelChange)="onLatitudeChange($event)"
        />
      </label>
      <label>
        <span>{{ 'LISTINGS.FIELD_LONGITUDE' | translate }}</span>
        <input
          type="number"
          step="0.000001"
          [ngModel]="form.longitude"
          (ngModelChange)="onLongitudeChange($event)"
        />
      </label>
      <div class="full">
        <div id="listing-location-map" class="listing-map"></div>
      </div>
      <label class="full">
        <span>{{ 'LISTINGS.FIELD_DESCRIPTION' | translate }}</span>
        <textarea rows="3" [(ngModel)]="form.description"></textarea>
      </label>
      <div class="full image-uploader">
        <span class="label">{{ 'LISTINGS.FIELD_IMAGES' | translate }}</span>
        <input type="file" accept="image/jpeg,image/png,image/webp" multiple (change)="onImagesSelected($event)" />
        <p class="hint">{{ 'LISTINGS.FIELD_IMAGES_HINT' | translate }}</p>
        <div class="image-previews" *ngIf="imagePreviews.length > 0">
          <div class="preview" *ngFor="let preview of imagePreviews; let idx = index">
            <img [src]="preview" alt="Listing preview" />
            <button type="button" class="ghost-btn" (click)="removeImage(idx)">
              {{ 'LISTINGS.REMOVE_IMAGE' | translate }}
            </button>
          </div>
        </div>
      </div>
      <label class="toggle">
        <input type="checkbox" [(ngModel)]="form.active" />
        <span>{{ 'LISTINGS.FIELD_ACTIVE' | translate }}</span>
      </label>
    </div>

    <div class="form-actions">
      <button class="primary-btn" type="button" (click)="saveListing()" [disabled]="isSaving">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>

  <div class="listings-grid" *ngIf="!isLoading">
    <div class="account-card listing-card" *ngFor="let listing of listings">
      <div class="listing-image" *ngIf="listing.imageUrls?.length">
        <img [src]="getImageUrl(listing.imageUrls[0])" [alt]="listing.name" />
      </div>
      <div class="listing-header">
        <div>
          <h3>{{ listing.name }}</h3>
          <p class="muted">{{ listing.sku }}</p>
        </div>
        <span class="pill" [class.pill--inactive]="!listing.active">
          {{ listing.active ? ('LISTINGS.STATUS_ACTIVE' | translate) : ('LISTINGS.STATUS_INACTIVE' | translate) }}
        </span>
      </div>
      <div class="listing-meta">
        <div>
          <span>{{ 'LISTINGS.LABEL_PRICE' | translate }}</span>
          <strong>{{ listing.price }} {{ listing.currency }}</strong>
        </div>
        <div>
          <span>{{ 'LISTINGS.LABEL_STOCK' | translate }}</span>
          <strong>{{ listing.stockQty }}</strong>
        </div>
        <div *ngIf="listing.brand">
          <span>{{ 'LISTINGS.LABEL_BRAND' | translate }}</span>
          <strong>{{ listing.brand }}</strong>
        </div>
      </div>
      <p class="listing-desc" *ngIf="listing.description">{{ listing.description }}</p>
      <div class="listing-actions">
        <button class="ghost-btn" type="button" (click)="openEditListing(listing)">
          {{ 'LISTINGS.EDIT' | translate }}
        </button>
        <button class="danger-btn" type="button" (click)="deleteListing(listing)" [disabled]="isSaving">
          {{ 'LISTINGS.DELETE' | translate }}
        </button>
      </div>
    </div>

    <div class="account-card empty-card" *ngIf="listings.length === 0">
      <p>{{ 'LISTINGS.EMPTY' | translate }}</p>
    </div>
  </div>
</section>
